<template>
  <v-card class="pg2-section">
    <div class="pg2-section-title d-flex align-center" style="gap:8px;">
      <v-icon color="teal darken-2" small>mdi-domain</v-icon>
      Sucursal para factura
    </div>
    <v-card-text>
      <v-progress-linear v-if="loading" indeterminate color="teal" class="mb-3" />
      <v-row dense >
        <v-col cols="12" md="8">
          <v-select
            v-model="sucursalSel"
            :items="sucursales"
            item-text="text_nit"
            return-object
            label="Sucursal del programa para la factura"
            dense outlined hide-details
            prepend-inner-icon="mdi-office-building"
            :loading="loading"
            :clearable="canEdit"
            :disabled="!canEdit"
            @change="$emit('change', sucursalSel ? sucursalSel.text_nit : null)"
          />
          <div class="text-caption text--secondary mt-1">
            Para emisión de recibo y factura debe seleccionar la sucursal
          </div>
        </v-col>
        <v-col cols="auto" class="d-flex">
          <v-btn color="teal darken-1" :loading="saving" :disabled="!canEdit || !sucursalSel"
            class="white--text" @click="guardar">
            <v-icon left small>mdi-content-save</v-icon>
            Asignar sucursal
          </v-btn>
        </v-col>
      </v-row>
      <div v-if="mensajeGuardado" class="mt-3">
        <v-chip small color="teal lighten-5" class="teal--text text--darken-3">
          <v-icon left small>mdi-check-circle-outline</v-icon>
          {{ mensajeGuardado }}
        </v-chip>
      </div>
    </v-card-text>
  </v-card>
</template>

<script>
import gql from 'graphql-tag';
import { getheadersrest } from '@/components/Utils';

export default {
  name: 'SucursalFactura',
  props: {
    programaId: { type: Number, required: true },
    sedeId: { type: Number, required: true },
    sucursalId: { type: Number, default: null },
    canEdit: { type: Boolean, default: true },
  },
  data() {
    return {
      loading: false,
      saving: false,
      sucursales: [],
      sucursalSel: null,
      mensajeGuardado: null,
    };
  },
  watch: {
    sedeId(val) {
      if (val) this.cargar();
    },
  },
  methods: {
    async cargar() {
      if (!this.sedeId) return;
      this.loading = true;
      const sql = gql`query{ getSucursalesByIdSede(id:${this.sedeId}){ id, nit_id, direccion, telefono, ciudad, numero_sucursal, nit{ nro, nombre } } }`;
      const data = await this.$apollo.query({ query: sql, fetchPolicy: 'network-only' })
        .then(d => d.data).catch(() => null);
      this.loading = false;
      if (!data || !data.getSucursalesByIdSede) return;
      this.sucursales = data.getSucursalesByIdSede.map(s => ({
        ...s,
        text_nit: s.nit
          ? `${s.nit.nro} - ${s.nit.nombre} [${s.direccion || s.ciudad || ''}]`
          : `Sucursal ${s.id}`,
      }));
      if (this.sucursalId) {
        const found = this.sucursales.find(s => s.id === this.sucursalId);
        if (found) {
          this.sucursalSel = found;
          this.$emit('change', found.text_nit);
          this.mensajeGuardado = `Sucursal asignada: ${found.text_nit}`;
        }
      }
    },
    async guardar() {
      if (!this.sucursalSel) return;
      this.saving = true;
      const res = await fetch(
        `${process.env.VUE_APP_API_REST}/api/esam/programa/sucursal/insertar`,
        {
          method: 'POST',
          headers: getheadersrest(),
          body: JSON.stringify({ programa_id: this.programaId, sucursal_id: this.sucursalSel.id }),
        }
      ).then(r => r.json()).catch(() => null);
      this.saving = false;
      window.console.log('res',res);
      
      if (res && (res.ok || res.id || res.programa_id || res.sucursal_id || res.result == 'success')) {
        this.mensajeGuardado = `Sucursal asignada: ${this.sucursalSel.text_nit}`;
        this.$root.$notify.show('Sucursal asignada correctamente', { color: '#0c9689', x: 'right' });
        this.$emit('change', this.sucursalSel.text_nit);
      } else {
        this.$root.$notify.show(
          (res && (res.error || res.message)) || 'Error al asignar sucursal',
          { color: 'red', x: 'right' }
        );
      }
    },
  },
  mounted() {
    if (this.sedeId) this.cargar();
  },
};
</script>

<style src="./estilos_registro_programa.css"></style>
